require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./news-2026-02-04-our-team-identifies-a-new-weakness-in-pancreatic-cancer-opening-the-door-to-novel-combination-therapies.json") })
        }
      }, "path---news-2026-02-04-our-team-identifies-a-new-weakness-in-pancreatic-cancer-opening-the-door-to-novel-combination-therapies");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---news-2026-02-04-our-team-identifies-a-new-weakness-in-pancreatic-cancer-opening-the-door-to-novel-combination-therapies!./.cache/json/news-2026-02-04-our-team-identifies-a-new-weakness-in-pancreatic-cancer-opening-the-door-to-novel-combination-therapies.json
// module id = 479
// module chunks = 231608221292675